import React, { useState, useEffect } from "react";
import { Plus, CheckCircle, Power, Pencil, Trash2, X, Users, ShieldCheck, ShieldOff } from "lucide-react";
import { api } from "../../utils/api";

const money = n => new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(n || 0);
const fmt = d => d ? new Date(d).toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—";

export default function Periods() {
  const [periods, setPeriods] = useState([]);
  const [owners, setOwners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null); // null veya düzenlenecek/yeni period objesi

  const load = () => {
    setLoading(true);
    api.get("/periods").then(r => {
      // Başlangıç tarihine göre yeniden eskiye sırala
      const sorted = (r.data || []).sort((a, b) => (b.start_date || "").localeCompare(a.start_date || ""));
      setPeriods(sorted);
      setLoading(false);
    }).catch(() => setLoading(false));

    api.get("/owners").then(r => setOwners(r.data || [])).catch(() => {});
  };

  useEffect(() => { load(); }, []);

  // Dönemi Aktif Yapma
  const makeActive = async (p) => {
    if (!window.confirm(`"${p.name}" dönemini aktif dönem yapmak istediğinize emin misiniz?`)) return;
    try {
      await api.post("/periods", { ...p, active: true });
      load();
    } catch (err) {
      alert("Dönem aktif yapılamadı.");
    }
  };

  // Dönem Silme
  const remove = async (name) => {
    if (!window.confirm(`"${name}" dönemini silmek istediğinize emin misiniz?`)) return;
    try {
      await api.delete(`/periods/${encodeURIComponent(name)}`);
      load();
    } catch (err) {
      alert("Silme işlemi başarısız oldu.");
    }
  };

  return (
    <div style={{ animation: "fadeIn 0.4s ease-out" }}>
      
      {/* ÜST BAŞLIK KARTI */}
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", background: "white", padding: "24px 30px", borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 4px 6px rgba(0,0,0,0.02)", marginBottom: "24px", gap: "20px" }}>
        <div>
          <span style={{ fontSize: "12px", fontWeight: "bold", color: "#0d9488", letterSpacing: "1px", textTransform: "uppercase" }}>SİTE YÖNETİMİ</span>
          <h2 style={{ margin: "6px 0", fontSize: "24px", color: "#1e293b" }}>Dönemler ve Aidat Planı</h2>
          <p style={{ margin: 0, fontSize: "14px", color: "#64748b" }}>Yıllık bütçe dönemlerini, aidat artışlarını ve dönem yönetim kurulu muafiyetlerini yönetin.</p>
        </div>
        <button 
          onClick={() => setModal({})} 
          style={{ display: "flex", alignItems: "center", gap: "8px", background: "#0d9488", color: "white", border: "none", padding: "12px 22px", borderRadius: "10px", fontWeight: "bold", fontSize: "14px", cursor: "pointer", boxShadow: "0 4px 12px rgba(13, 148, 136, 0.25)" }}
        >
          <Plus size={18} /> Yeni Dönem Aç
        </button>
      </div>

      {/* TABLO */}
      {loading ? (
        <div style={{ padding: "40px", textAlign: "center", color: "#64748b" }}>Dönemler yükleniyor...</div>
      ) : (
        <div style={{ background: "white", borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 4px 6px rgba(0,0,0,0.02)", overflow: "hidden" }}>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
              <thead>
                <tr style={{ background: "#f8fafc", borderBottom: "2px solid #e2e8f0" }}>
                  <th style={{ padding: "16px", fontSize: "13px", color: "#64748b", fontWeight: "600" }}>Dönem Adı</th>
                  <th style={{ padding: "16px", fontSize: "13px", color: "#64748b", fontWeight: "600" }}>Başlangıç - Bitiş</th>
                  <th style={{ padding: "16px", fontSize: "13px", color: "#64748b", fontWeight: "600" }}>1. Aidat</th>
                  <th style={{ padding: "16px", fontSize: "13px", color: "#64748b", fontWeight: "600" }}>2. Aidat</th>
                  <th style={{ padding: "16px", fontSize: "13px", color: "#64748b", fontWeight: "600" }}>Yıllık Tahakkuk</th>
                  <th style={{ padding: "16px", fontSize: "13px", color: "#64748b", fontWeight: "600" }}>Yönetim Kurulu & Hesap Kodları</th>
                  <th style={{ padding: "16px", fontSize: "13px", color: "#64748b", fontWeight: "600" }}>Yönetici Aidatı</th>
                  <th style={{ padding: "16px", fontSize: "13px", color: "#64748b", fontWeight: "600" }}>Durum</th>
                  <th style={{ padding: "16px", fontSize: "13px", color: "#64748b", fontWeight: "600", textAlign: "center" }}>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {periods.map(p => {
                  const yillikToplam = p.donem_aidat_toplami || ((Number(p.due_1 || 0) * Number(p.due_1_months || 0)) + (Number(p.due_2 || 0) * Number(p.due_2_months || 0)));
                  return (
                    <tr key={p.name} style={{ borderBottom: "1px solid #f1f5f9", background: p.active ? "#f0fdf4" : "white" }}>
                      
                      {/* Dönem Adı */}
                      <td style={{ padding: "16px", fontWeight: "bold", fontSize: "16px", color: p.active ? "#15803d" : "#1e293b" }}>
                        {p.name}
                      </td>

                      {/* Başlangıç - Bitiş */}
                      <td style={{ padding: "16px", fontSize: "13px", color: "#475569", lineHeight: "1.5" }}>
                        <div>{fmt(p.start_date)}</div>
                        <div>{fmt(p.end_date)}</div>
                      </td>

                      {/* 1. Aidat */}
                      <td style={{ padding: "16px" }}>
                        <strong style={{ display: "block", color: "#1e293b", fontSize: "15px" }}>{money(p.due_1)}</strong>
                        <small style={{ color: "#64748b", fontSize: "12px", display: "block" }}>x {p.due_1_months || 0} Ay</small>
                        {p.due_1_date && <small style={{ color: "#94a3b8", fontSize: "11px" }}>Başl: {fmt(p.due_1_date)}</small>}
                      </td>

                      {/* 2. Aidat */}
                      <td style={{ padding: "16px" }}>
                        {Number(p.due_2) > 0 ? (
                          <>
                            <strong style={{ display: "block", color: "#1e293b", fontSize: "15px" }}>{money(p.due_2)}</strong>
                            <small style={{ color: "#64748b", fontSize: "12px", display: "block" }}>x {p.due_2_months || 0} Ay</small>
                            {p.due_2_date && <small style={{ color: "#94a3b8", fontSize: "11px" }}>Başl: {fmt(p.due_2_date)}</small>}
                          </>
                        ) : (
                          <span style={{ color: "#94a3b8" }}>—</span>
                        )}
                      </td>

                      {/* Yıllık Tahakkuk */}
                      <td style={{ padding: "16px", fontWeight: "bold", fontSize: "16px", color: "#0f766e" }}>
                        {money(yillikToplam)}
                      </td>

                      {/* Yönetim Kurulu (Başkan, Yrd, Muhasip ve Kodları) */}
                      <td style={{ padding: "16px", fontSize: "13px", lineHeight: "1.6" }}>
                        {p.baskan || p.bsk_hes_kodu ? (
                          <div>
                            <span style={{ color: "#64748b", fontWeight: "600" }}>Bşk:</span>{" "}
                            <strong style={{ color: "#1e293b" }}>{p.baskan || "—"}</strong>{" "}
                            {p.bsk_hes_kodu && <span style={{ background: "#e2e8f0", color: "#334155", padding: "1px 6px", borderRadius: "4px", fontSize: "11px", fontWeight: "bold" }}>{p.bsk_hes_kodu}</span>}
                          </div>
                        ) : null}
                        {p.baskan_yrd || p.bsk_yrd_hes_kodu ? (
                          <div>
                            <span style={{ color: "#64748b", fontWeight: "600" }}>Yrd:</span>{" "}
                            <strong style={{ color: "#1e293b" }}>{p.baskan_yrd || "—"}</strong>{" "}
                            {p.bsk_yrd_hes_kodu && <span style={{ background: "#e2e8f0", color: "#334155", padding: "1px 6px", borderRadius: "4px", fontSize: "11px", fontWeight: "bold" }}>{p.bsk_yrd_hes_kodu}</span>}
                          </div>
                        ) : null}
                        {p.muhasip || p.muh_hes_kodu ? (
                          <div>
                            <span style={{ color: "#64748b", fontWeight: "600" }}>Muh:</span>{" "}
                            <strong style={{ color: "#1e293b" }}>{p.muhasip || "—"}</strong>{" "}
                            {p.muh_hes_kodu && <span style={{ background: "#e2e8f0", color: "#334155", padding: "1px 6px", borderRadius: "4px", fontSize: "11px", fontWeight: "bold" }}>{p.muh_hes_kodu}</span>}
                          </div>
                        ) : null}
                        {!p.baskan && !p.baskan_yrd && !p.muhasip && !p.bsk_hes_kodu && !p.bsk_yrd_hes_kodu && !p.muh_hes_kodu && (
                          <span style={{ color: "#94a3b8", fontStyle: "italic" }}>Tanımlanmamış</span>
                        )}
                      </td>

                      {/* Yönetici Aidat Öder mi? */}
                      <td style={{ padding: "16px" }}>
                        {p.aidat_oder_mi ? (
                          <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", background: "#dbeafe", color: "#1d4ed8", padding: "5px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "bold" }}>
                            <ShieldCheck size={14} /> Aidat Öder (Evet)
                          </span>
                        ) : (
                          <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", background: "#fef3c7", color: "#b45309", padding: "5px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "bold" }}>
                            <ShieldOff size={14} /> Muaf (Hayır)
                          </span>
                        )}
                      </td>

                      {/* Durum */}
                      <td style={{ padding: "16px" }}>
                        {p.active ? (
                          <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", background: "#16a34a", color: "white", padding: "6px 12px", borderRadius: "20px", fontSize: "12px", fontWeight: "bold" }}>
                            <CheckCircle size={14} /> Aktif
                          </span>
                        ) : (
                          <span style={{ display: "inline-block", background: "#f1f5f9", color: "#64748b", padding: "6px 12px", borderRadius: "20px", fontSize: "12px", fontWeight: "600" }}>
                            Pasif
                          </span>
                        )}
                      </td>

                      {/* İşlemler */}
                      <td style={{ padding: "16px", textAlign: "center" }}>
                        <div style={{ display: "inline-flex", gap: "6px" }}>
                          {!p.active && (
                            <button onClick={() => makeActive(p)} title="Aktif Dönem Yap" style={{ background: "#f0fdf4", color: "#16a34a", border: "1px solid #bbf7d0", padding: "8px", borderRadius: "8px", cursor: "pointer" }}>
                              <Power size={16} />
                            </button>
                          )}
                          <button onClick={() => setModal(p)} title="Düzenle" style={{ background: "#eff6ff", color: "#3b82f6", border: "1px solid #bfdbfe", padding: "8px", borderRadius: "8px", cursor: "pointer" }}>
                            <Pencil size={16} />
                          </button>
                          {!p.active && (
                            <button onClick={() => remove(p.name)} title="Sil" style={{ background: "#fef2f2", color: "#ef4444", border: "1px solid #fecaca", padding: "8px", borderRadius: "8px", cursor: "pointer" }}>
                              <Trash2 size={16} />
                            </button>
                          )}
                        </div>
                      </td>

                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* MODAL PENCERESİ */}
      {modal !== null && (
        <PeriodModal 
          initial={modal.name ? modal : null} 
          owners={owners} 
          close={() => setModal(null)} 
          done={() => { setModal(null); load(); }} 
        />
      )}

    </div>
  );
}

// ============================================================================
// YENİ DÖNEM EKLEME / DÜZENLEME MODALI (TÜM VERİTABANI ALANLARI DÂHİL)
// ============================================================================
function PeriodModal({ initial, owners, close, done }) {
  const [form, setForm] = useState(initial || {
    name: "2026-2027",
    start_date: "2026-05-16",
    end_date: "2027-05-21",
    active: false,
    due_1: 2500,
    due_1_date: "2026-06-01",
    due_1_months: 7,
    due_2: 3000,
    due_2_date: "2027-01-01",
    due_2_months: 5,
    donem_aidat_toplami: 32500,
    baskan: "",
    bsk_hes_kodu: "",
    baskan_yrd: "",
    bsk_yrd_hes_kodu: "",
    muhasip: "",
    muh_hes_kodu: "",
    aidat_oder_mi: false
  });

  // 1. ve 2. aidat veya ay sayısı değiştiğinde dönem toplamını otomatik güncelle
  useEffect(() => {
    const total = (Number(form.due_1 || 0) * Number(form.due_1_months || 0)) + (Number(form.due_2 || 0) * Number(form.due_2_months || 0));
    setForm(prev => ({ ...prev, donem_aidat_toplami: total }));
  }, [form.due_1, form.due_1_months, form.due_2, form.due_2_months]);

  const change = e => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  // Malik listesinden yönetici seçildiğinde hem adını hem hesap kodunu otomatik doldurur
  const handleSelectBoardMember = (rolePrefix, selectedCode) => {
    const found = owners.find(o => o.accounting_code === selectedCode);
    const personName = found ? (found.owner_name || found.resident_name || "") : "";
    
    if (rolePrefix === "baskan") {
      setForm(prev => ({ ...prev, bsk_hes_kodu: selectedCode, baskan: personName || prev.baskan }));
    } else if (rolePrefix === "baskan_yrd") {
      setForm(prev => ({ ...prev, bsk_yrd_hes_kodu: selectedCode, baskan_yrd: personName || prev.baskan_yrd }));
    } else if (rolePrefix === "muhasip") {
      setForm(prev => ({ ...prev, muh_hes_kodu: selectedCode, muhasip: personName || prev.muhasip }));
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    const payload = {
      ...form,
      due_1: Number(form.due_1 || 0),
      due_1_months: Number(form.due_1_months || 0),
      due_2: Number(form.due_2 || 0),
      due_2_months: Number(form.due_2_months || 0),
      donem_aidat_toplami: Number(form.donem_aidat_toplami || 0),
      aidat_oder_mi: Boolean(form.aidat_oder_mi),
      active: Boolean(form.active)
    };

    try {
      await api.post("/periods", payload);
      done();
    } catch (err) {
      alert("Dönem kaydedilirken bir hata oluştu.");
    }
  };

  const labelStyle = { display: "block", fontSize: "12px", fontWeight: "600", color: "#475569", marginBottom: "5px" };
  const inputStyle = { width: "100%", padding: "9px 12px", borderRadius: "8px", border: "1px solid #cbd5e1", outline: "none", fontSize: "14px" };

  return (
    <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(15, 23, 42, 0.6)", backdropFilter: "blur(4px)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: "16px" }}>
      <div style={{ background: "white", width: "100%", maxWidth: "720px", borderRadius: "20px", boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)", overflow: "hidden" }}>
        
        {/* MODAL BAŞLIĞI */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 26px", borderBottom: "1px solid #e2e8f0", background: "#f0fdf4" }}>
          <div>
            <span style={{ fontSize: "11px", fontWeight: "bold", color: "#0d9488", letterSpacing: "1px" }}>
              {initial ? "DÖNEM BİLGİLERİNİ GÜNCELLE" : "YENİ BÜTÇE DÖNEMİ"}
            </span>
            <h2 style={{ margin: "4px 0 0 0", fontSize: "20px", color: "#1e293b" }}>
              {initial ? `${initial.name} Dönemi` : "Yeni Dönem ve Aidat Planı Aç"}
            </h2>
          </div>
          <button onClick={close} style={{ background: "none", border: "none", color: "#64748b", cursor: "pointer" }}><X size={24} /></button>
        </div>

        <form onSubmit={submit} style={{ padding: "24px 26px", maxHeight: "80vh", overflowY: "auto" }}>
          
          {/* 1. BÖLÜM: DÖNEM TARİHLERİ VE DURUMU */}
          <div style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr 1fr", gap: "16px", marginBottom: "18px" }}>
            <div>
              <label style={labelStyle}>Dönem Adı (Örn: 2026-2027) *</label>
              <input name="name" value={form.name} onChange={change} required style={{ ...inputStyle, fontWeight: "bold" }} />
            </div>
            <div>
              <label style={labelStyle}>Dönem Başlangıç Tarihi *</label>
              <input name="start_date" type="date" value={form.start_date} onChange={change} required style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Dönem Bitiş Tarihi *</label>
              <input name="end_date" type="date" value={form.end_date} onChange={change} required style={inputStyle} />
            </div>
          </div>

          {/* 2. BÖLÜM: 1. VE 2. YARI AİDAT PLANI */}
          <div style={{ background: "#f8fafc", padding: "18px", borderRadius: "12px", border: "1px solid #e2e8f0", marginBottom: "18px" }}>
            <h4 style={{ margin: "0 0 14px 0", fontSize: "14px", color: "#1e293b" }}>Aidat ve Tahakkuk Planı</h4>
            
            {/* 1. Aidat */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "14px", marginBottom: "14px" }}>
              <div>
                <label style={labelStyle}>1. Aidat Tutarı (TL)</label>
                <input name="due_1" type="number" value={form.due_1} onChange={change} required style={{ ...inputStyle, fontWeight: "bold", color: "#0f766e" }} />
              </div>
              <div>
                <label style={labelStyle}>1. Aidat Başlangıç Tarihi</label>
                <input name="due_1_date" type="date" value={form.due_1_date} onChange={change} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>1. Aidat Ay Sayısı (Süre)</label>
                <input name="due_1_months" type="number" value={form.due_1_months} onChange={change} required style={inputStyle} />
              </div>
            </div>

            {/* 2. Aidat */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "14px", marginBottom: "14px" }}>
              <div>
                <label style={labelStyle}>2. Aidat Tutarı (TL)</label>
                <input name="due_2" type="number" value={form.due_2} onChange={change} style={{ ...inputStyle, fontWeight: "bold", color: "#0f766e" }} />
              </div>
              <div>
                <label style={labelStyle}>2. Aidat Başlangıç Tarihi</label>
                <input name="due_2_date" type="date" value={form.due_2_date} onChange={change} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>2. Aidat Ay Sayısı (Süre)</label>
                <input name="due_2_months" type="number" value={form.due_2_months} onChange={change} style={inputStyle} />
              </div>
            </div>

            {/* Dönem Aidat Toplamı */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: "12px", borderTop: "1px dashed #cbd5e1" }}>
              <span style={{ fontSize: "13px", fontWeight: "600", color: "#475569" }}>Dönem Yıllık Aidat Toplamı (`donem_aidat_toplami`):</span>
              <span style={{ fontSize: "18px", fontWeight: "900", color: "#0d9488" }}>{money(form.donem_aidat_toplami)}</span>
            </div>
          </div>

          {/* 3. BÖLÜM: YÖNETİM KURULU VE HESAP KODLARI (BAKİYE RAPORU MUAFİYETİ İÇİN) */}
          <div style={{ background: "#fffbeb", padding: "18px", borderRadius: "12px", border: "1px solid #fde68a", marginBottom: "18px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "14px", flexWrap: "wrap", gap: "10px" }}>
              <div>
                <h4 style={{ margin: 0, fontSize: "14px", color: "#92400e", display: "flex", alignItems: "center", gap: "6px" }}>
                  <Users size={16} /> Dönem Yönetim Kurulu ve Hesap Kodları
                </h4>
                <small style={{ color: "#b45309", fontSize: "12px" }}>Bakiye raporlarında aidat muafiyeti uygulanacak yönetim kurulu üyelerini seçin.</small>
              </div>

              {/* aidat_oder_mi Checkbox */}
              <label style={{ display: "flex", alignItems: "center", gap: "8px", background: "white", padding: "8px 12px", borderRadius: "8px", border: "1px solid #fcd34d", cursor: "pointer", fontSize: "13px", fontWeight: "bold", color: "#78350f" }}>
                <input 
                  type="checkbox" 
                  name="aidat_oder_mi" 
                  checked={form.aidat_oder_mi} 
                  onChange={change} 
                  style={{ width: "16px", height: "16px" }} 
                />
                Yöneticiler Aidat Öder mi? ({form.aidat_oder_mi ? "Evet, Öder" : "Hayır, Muaf"})
              </label>
            </div>

            {/* Başkan */}
            <div style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr 0.8fr", gap: "12px", marginBottom: "12px" }}>
              <div>
                <label style={labelStyle}>Malik Listesinden Hızlı Seç (Başkan)</label>
                <select value={form.bsk_hes_kodu || ""} onChange={e => handleSelectBoardMember("baskan", e.target.value)} style={{ ...inputStyle, background: "white" }}>
                  <option value="">— Malik Seçiniz —</option>
                  {owners.map(o => (
                    <option key={o.accounting_code} value={o.accounting_code}>
                      {o.accounting_code} - {o.owner_name || o.resident_name || o.villa_no}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label style={labelStyle}>Başkan Adı Soyadı (`baskan`)</label>
                <input name="baskan" value={form.baskan || ""} onChange={change} placeholder="Ad soyad" style={{ ...inputStyle, background: "white" }} />
              </div>
              <div>
                <label style={labelStyle}>Başkan Hes. Kodu (`bsk_hes_kodu`)</label>
                <input name="bsk_hes_kodu" value={form.bsk_hes_kodu || ""} onChange={change} placeholder="Örn: 120.xx" style={{ ...inputStyle, background: "white", fontWeight: "bold" }} />
              </div>
            </div>

            {/* Başkan Yardımcısı */}
            <div style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr 0.8fr", gap: "12px", marginBottom: "12px" }}>
              <div>
                <label style={labelStyle}>Malik Listesinden Hızlı Seç (Başkan Yrd.)</label>
                <select value={form.bsk_yrd_hes_kodu || ""} onChange={e => handleSelectBoardMember("baskan_yrd", e.target.value)} style={{ ...inputStyle, background: "white" }}>
                  <option value="">— Malik Seçiniz —</option>
                  {owners.map(o => (
                    <option key={o.accounting_code} value={o.accounting_code}>
                      {o.accounting_code} - {o.owner_name || o.resident_name || o.villa_no}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label style={labelStyle}>Başkan Yrd. Adı (`baskan_yrd`)</label>
                <input name="baskan_yrd" value={form.baskan_yrd || ""} onChange={change} placeholder="Ad soyad" style={{ ...inputStyle, background: "white" }} />
              </div>
              <div>
                <label style={labelStyle}>Bşk. Yrd. Hes. Kodu (`bsk_yrd_hes_kodu`)</label>
                <input name="bsk_yrd_hes_kodu" value={form.bsk_yrd_hes_kodu || ""} onChange={change} placeholder="Örn: 120.xx" style={{ ...inputStyle, background: "white", fontWeight: "bold" }} />
              </div>
            </div>

            {/* Muhasip */}
            <div style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr 0.8fr", gap: "12px" }}>
              <div>
                <label style={labelStyle}>Malik Listesinden Hızlı Seç (Muhasip)</label>
                <select value={form.muh_hes_kodu || ""} onChange={e => handleSelectBoardMember("muhasip", e.target.value)} style={{ ...inputStyle, background: "white" }}>
                  <option value="">— Malik Seçiniz —</option>
                  {owners.map(o => (
                    <option key={o.accounting_code} value={o.accounting_code}>
                      {o.accounting_code} - {o.owner_name || o.resident_name || o.villa_no}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label style={labelStyle}>Muhasip Adı (`muhasip`)</label>
                <input name="muhasip" value={form.muhasip || ""} onChange={change} placeholder="Ad soyad" style={{ ...inputStyle, background: "white" }} />
              </div>
              <div>
                <label style={labelStyle}>Muhasip Hes. Kodu (`muh_hes_kodu`)</label>
                <input name="muh_hes_kodu" value={form.muh_hes_kodu || ""} onChange={change} placeholder="Örn: 120.xx" style={{ ...inputStyle, background: "white", fontWeight: "bold" }} />
              </div>
            </div>
          </div>

          {/* AKTİF DÖNEM SEÇENEĞİ VE KAYDET BUTONLARI */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px" }}>
            <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "14px", fontWeight: "600", color: "#1e293b" }}>
              <input type="checkbox" name="active" checked={form.active} onChange={change} style={{ width: "18px", height: "18px" }} />
              Bu dönemi sistemin "Aktif Dönemi" olarak ayarla
            </label>

            <div style={{ display: "flex", gap: "10px" }}>
              <button type="button" onClick={close} style={{ padding: "11px 20px", background: "white", border: "1px solid #cbd5e1", borderRadius: "8px", color: "#475569", fontWeight: "600", cursor: "pointer" }}>
                Vazgeç
              </button>
              <button type="submit" style={{ padding: "11px 24px", background: "#0d9488", border: "none", borderRadius: "8px", color: "white", fontWeight: "bold", cursor: "pointer", boxShadow: "0 4px 12px rgba(13, 148, 136, 0.25)" }}>
                {initial ? "Dönemi Güncelle" : "Dönemi Kaydet"}
              </button>
            </div>
          </div>

        </form>
      </div>
    </div>
  );
}